const scrollToTopWrapper = document.querySelector(".scroll-top");
const reducedMotionPreferred = window.matchMedia("(prefers-reduced-motion: reduce)");

// check for the existamce of a sticky add at the bottom on multi-fluid page types
const stickyAd = document.querySelector("#dfp-mobile-footer");

let winheight, docheight, trackLength, scrollToTopBottomDistance;
let previousScrollPosition = 0;

/**
 * function to return doc height
 * @returns height
 */
const getDocHeight = () => {
    return Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
    )
}

/**
 * setting required measurements
 */
const setMeasurements = () => {
    winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
    docheight = getDocHeight();
    trackLength = docheight - winheight;
}

/**
 * function to find percentage scrolled
 * @returns prctScrolled
 */
const percentageScrolled = () => {
    let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let prctScrolled = Math.floor(scrollTop/trackLength * 100);
    return prctScrolled;
}

/**
 * function handle click event
 * @param {*} e 
 */
const scrollToTopHandler = (e) => {
    if (reducedMotionPreferred && !reducedMotionPreferred.matches) {
        e.preventDefault();    
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        // delay is added for scrollTo animation to finish and then set the focus to top.
        // @todo need to find a better solution for listening to the end of scrolling animation above
        setTimeout(() => {document.getElementById("page-top").focus(); scrollToTopWrapper.blur()}, 1000);  
   }
}

/**
 * function to decide scroll direction
 * @returns true|false
 */
const isScrollingUp = () => {
    let currentScrolledPosition = window.scrollY || window.pageYOffset;
    let scrollingUp = true;

    if (currentScrolledPosition > previousScrollPosition) {
        scrollingUp = false;
    }

    previousScrollPosition = currentScrolledPosition <= 0 ? 0 : currentScrolledPosition;   
    return scrollingUp;
}

/**
 * function handling the visibility logic of scrollToTop buttton
 */
const handleScrollToTopVisibility = () => {
    if ( (isScrollingUp() && (percentageScrolled() > 5)) ) {      
        scrollToTopWrapper.classList.add("scroll-top--visible");

        // there appears to be a sticky ad in the bottom of multi-fluid page type and scrollToTop 
        // buttom seems to be covering this ad. To prevent this, the bottom height has been increased to 
        // position this button on top of the ad section.
        scrollToTopBottomDistance = ( stickyAd && stickyAd.offsetHeight ) ? stickyAd.offsetHeight  : 8;  
        scrollToTopWrapper.style.bottom = scrollToTopBottomDistance + "px";
    } else {
        if (scrollToTopWrapper.classList.contains('scroll-top--visible')) {
            scrollToTopWrapper.classList.remove("scroll-top--visible");
        }
    }
}
  
/* Main function */
const scrollToTop = () => {
    if (scrollToTopWrapper) { 
        
        //set the required measurements
        setMeasurements();

        // optimising scroll event by executing only once every 250 ms
        let throttleTimer;
        const throttle = (callback, time) => {
            if (throttleTimer) return;
            throttleTimer = true;
            setTimeout(() => {
                callback();
                throttleTimer = false;
            }, time);
        };

        // Add Event Listeners
        scrollToTopWrapper.addEventListener("click", scrollToTopHandler);
        
        //and only refresh them when the page has resized, instead of each time the page is scrolled.
        window.addEventListener("resize", () => { setMeasurements(); }, false)
        window.addEventListener("scroll", () => { throttle(handleScrollToTopVisibility, 250) });
    }
}

export default scrollToTop;